module.exports = __webpack_public_path__ + "img/tyby.6f9dafb1.png";